import { isArray } from "util";

function handleBeneficiaries(schema, otherBeneficiaries, formData, onlyKosovo = false) {
    var indexOfProjectBeneficiary = getIndexOfProjectBeneficiaryField(schema);
    if (projectBeneficiaryFieldExists(indexOfProjectBeneficiary)) {
        if (onlyOtherBeneficiariesInProjectBeneficiary() || onlyKosovo) {
            assignOtherBeneficiariesToProjectBeneficiaryField(schema, otherBeneficiaries, indexOfProjectBeneficiary)
            addOnlyOtherBeneficiariesFlagToFormData(formData);
            console.log(formData);
        } else {
            if (!singleOtherBeneficiaryNeedsHandling(formData, otherBeneficiaries)) {
                removeOtherBeneficiariesFromNormalCountries(schema, otherBeneficiaries, indexOfProjectBeneficiary);
            } else {
                disableProjectBeneficiaryField(schema, indexOfProjectBeneficiary);
            }
        }
    }
}

function onlyOtherBeneficiariesInProjectBeneficiary() {
    var onlyOtherBeneficiariesParam = urlParam("onlyOtherBeneficiaries");
    return (onlyOtherBeneficiariesParam && onlyOtherBeneficiariesParam == "true")
}

function addOnlyOtherBeneficiariesFlagToFormData(formData) {
    formData.onlyOtherBeneficiaries = true;
}

// supports IE11 - don't change to URLParam class
function urlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    } else {
        return decodeURI(results[1]) || 0;
    }
}

function assignOtherBeneficiariesToProjectBeneficiaryField(schema, otherBeneficiaries, indexOfProjectBeneficiary) {
    schema[indexOfProjectBeneficiary].Values =
        schema[indexOfProjectBeneficiary].Values.filter(country => otherBeneficiaries.findIndex(ob => ob.toLowerCase() == country.toLowerCase()) > -1)
}

function singleOtherBeneficiaryNeedsHandling(formData, otherBeneficiaries) {
    if (formData.projectBeneficiary && !isArray(formData.projectBeneficiary)) {
        return otherBeneficiaries.findIndex(ob => ob.toLowerCase() == formData.projectBeneficiary.toLowerCase()) > -1;
    }

    return false;
}

function getIndexOfProjectBeneficiaryField(schema) {
    return schema.findIndex(field => field.Key == "projectBeneficiary");
}

function projectBeneficiaryFieldExists(indexOfProjectBeneficiary) {
    return indexOfProjectBeneficiary > -1;
}

function removeOtherBeneficiariesFromNormalCountries(schema, otherBeneficiaries, indexOfProjectBeneficiary) {
    schema[indexOfProjectBeneficiary].Values = schema[indexOfProjectBeneficiary].Values.filter(pb => otherBeneficiaries.findIndex(ob => {
        return ob.toLowerCase() == pb.toLowerCase();
    }) == -1);
}

function disableProjectBeneficiaryField(schema, indexOfProjectBeneficiary) {
    schema[indexOfProjectBeneficiary].Disabled = true;
}

export default {
    handleBeneficiaries
}


// WEBPACK FOOTER //
// ./src/services/projectBeneficiariesService.js